export enum InlineEditProperties {
  Status = 'status',
}
